// extracted by mini-css-extract-plugin
export default {"panel":"Panel_panel__6al3Z","animate-panel":"Panel_animate-panel__H2A9O"};